import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Header } from "../../components/Header"
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import DashboardPosts from './DashboardPosts'
import DashboardGroups from './DashboardGroups';
import DashboardAbout from './DashboardAbout';
import DashboardUsers from './DashboardUsers';
import DashboardEmailBuilder from './DashboardEmailBuilder'
import { getAllUsers, getAllGroups, getAboutBySite, getAllContent, getAnalytics, getApplications, getAllPrnd, getAllDocuments } from '../../actions';
import { Drawer } from '../../components/Drawer/Drawer';
import DashboardApplications from './DashboardApplications';
import DashboardPRND from './DashboardPRND';
import { esriSuggest } from '../../actions/portal/esri';
import DashboardDocuments from './DashboardDocuments';
import DashboardNotifications from './DashboardNotifications';
import DashboardAnalytics from './DashboardAnalytics';
import { getAllLayers } from '../../actions/portal/layer/getAllLayers';
import DashboardLayers from './DashboardLayers';
import DashboardCalendar from './DashboardCalendar';

function Dashboard() {
  const { user, token } = useSelector(state => state.authReducer);
  const [selectedTab, setSelectedTab] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    // initial render, get default tab data
    dispatch(getAllUsers(token));
    dispatch(getAllGroups(token));
    dispatch(getAllDocuments(token));
    dispatch(getAnalytics(token));
    if (user?.site?.id) {
      dispatch(getAboutBySite(user.site.id, token));
    }
    dispatch(getAllPrnd(token));
    dispatch(getAllContent(token));
    dispatch(getAllLayers(token));
  }, [user])

  const handleSelectTab = (event) => {
    switch (event.selected) {
    case 0: // Users tab
      dispatch(getAllUsers(token));
      dispatch(getAllGroups(token))
      break;
    case 1: // Groups tab
      dispatch(getAllGroups(token));
      break;
    case 2: // Posts tab
      dispatch(getAllContent(token));
      break;
    case 3: // About tab
      dispatch(getAboutBySite(user.site.id, token));
      break;
    case 4: // Application tab
      dispatch(getApplications(token));
      break;
    case 5: // PRND tab
      dispatch(getAllPrnd(token));
      break;
    case 6: //Docuemnts Tab
            //Get Documents
      break;
    default:
      break;
    }
    setSelectedTab(event.selected);
  };

  return (
    <div style={styles.dashboard}>
      <div style={styles.header}>
        <Header
          selectTab={(arg) => handleSelectTab(arg)}
        />
      </div>
      <div style={styles.tabstripDiv}>
        <TabStrip
          selected={selectedTab}
          onSelect={(e) => handleSelectTab(e)}
          tabPosition={"left"}
          style={styles.tabstrip}
        >
          <TabStripTab title="Users">
            <DashboardUsers />
          </TabStripTab>
          <TabStripTab title="Groups">
            <DashboardGroups />
          </TabStripTab>
          {user?.site?.sitePermissions?.some(perm => perm.permissionName === 'ANALYTICS') && !user?.viewOnly &&
            <TabStripTab title="Analytics" className='email-class'>
              <DashboardAnalytics />
            </TabStripTab>}
          <TabStripTab title="Posts">
            <DashboardPosts groups={[]} />
          </TabStripTab>
          <TabStripTab title="Calendar" contentClassName='calendar-class'>
            <DashboardCalendar />
          </TabStripTab>
          {user?.site?.sitePermissions?.some(perm => perm.permissionName === 'APPLICATIONS') &&
            <TabStripTab title="Applications">
              <DashboardApplications />
            </TabStripTab>}
          {user?.site?.sitePermissions?.some(perm => perm.permissionName === 'DOCUMENTS') && 
            <TabStripTab title="Documents">
              <DashboardDocuments /> 
            </TabStripTab>}
          {user?.site?.sitePermissions?.some(perm => perm.permissionName === 'EMAILBUILDER') && 
            <TabStripTab title="Email Builder" className='email-class'>
              <DashboardEmailBuilder />
            </TabStripTab>}
          {user?.site?.sitePermissions?.some(perm => perm.permissionName === 'NOTIFICATIONS') && 
            <TabStripTab title="Notification Builder" className='email-class'>
              <DashboardNotifications />
            </TabStripTab>}
          {user?.site?.sitePermissions?.some(perm => perm.permissionName === 'PRNDRESOURCES') &&
            <TabStripTab title="PRND">
              <DashboardPRND />
            </TabStripTab>}
          <TabStripTab title="Layers">
            <DashboardLayers />
          </TabStripTab>
          <TabStripTab title="About" contentClassName='about-class'>
            <DashboardAbout />
          </TabStripTab>
        </TabStrip>
      </div>
      <Drawer />
    </div>
  );
}

const styles = {
  dashboard: {
    background: '#dfdfdf',
  },
  header: {
    height: 66,
  },
  tabstripDiv: {
    height: 'calc(100vh - 66px)',
  },
  tabstrip: {
    height: '100%',
  }
}

export default Dashboard;
